import React from 'react';

import { Button, DialogActions as MuiDialogActions } from '@material-ui/core';

const DialogActions = ({ actions, children, ...props }) => (
  <MuiDialogActions {...props}>
    {actions
      ? actions.map((action, index) => (
          <Button
            key={`${action.label}_${index}`}
            disabled={action.disabled}
            onClick={action.onClick}
            color={action.color || 'primary'}
            variant={
              action.variant || (action.type === 'submit' ? 'contained' : undefined)
            }
            type={action.type}
          >
            {action.label}
          </Button>
        ))
      : null}

    {children}
  </MuiDialogActions>
);

export default DialogActions;
